import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "AutorPage",
    data() {
        let ss = new MainService();
        return {
            msg: " AutorPage",
            ss: ss,
            ajax: {
                "url": ss.indexAutor(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Autor', name: 'Autor', title: 'Autor' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            autores: [],
            autor: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newAutor() {
            this.autor = {};
            this.$refs['frm-autor'].show();
        },
        showAutor(id) {
            this.isLoading=true;
            this.ss.showAutor(id).then(
                (result) => {
                    let response = result.data;
                    this.autor = response.data;
                    this.$refs['view-autor'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editAutor() {
            this.$refs['frm-autor'].show();
            this.$refs['view-autor'].hide();
        },
        cancelAutor() {
            if (this.autor.id) {
                this.$refs['view-autor'].show();
            }
            this.$refs['frm-autor'].hide();
        },
        saveAutor() {
            this.ss.storeAutor(this.autor).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-autor'].hide();
                    this.$refs['datatable-autor'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteAutor() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyAutor(this.autor)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-autor'].hide();
                                this.$refs['datatable-autor'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Autor').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showAutor(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
